export enum FONTS {
    OPEN_SANS = 'open-sans, sans-serif',
    ARISTOTELICA = 'aristotelica, sans-serif',
    ARTISTOTELICA_EXTRALIGHT = 'aristotelica-extralight, sans-serif'
}

export enum FONT_SIZE {
    EXTRA_SHORT = '9px',
    SHORT = '13px',
}
